module.exports = require('../dist/contexts/AnalyticsContext');
